import * as React from "react";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";
import { NotificationFilterStore } from "../../Store/Variable";
import { NotificationAction } from "../../Action/NotificationAction";
import { DashboardTab } from "../../Resource/Content";
import { ClientNotificationFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel";
import { DashboardSummaryTiles } from "../Common/DashboardSummaryTiles";

interface INotificationFilterSummaryTilesProps {}

interface INotificationFilterSummaryTilesState {
    data?: ClientNotificationFiltersModel[];
    pressedId: number;
}

export class NotificationFilterSummaryTiles extends BaseComponent<
    INotificationFilterSummaryTilesProps,
    INotificationFilterSummaryTilesState
> {
    constructor(props: INotificationFilterSummaryTilesProps) {
        super(props);
        this.state = {
            data: null,
            pressedId: null,
        };
        this.subscribeToStore(NotificationFilterStore, () => this.onStoreChange());
    }

    componentDidMount() {
        const data = NotificationFilterStore.getData();
        if (!data) {
            NotificationAction.getFilterList();
        } else {
            this.setState({ data });
        }
    }

    private onStoreChange() {
        this.setState({ pressedId: NotificationFilterStore.getPressedId(), data: NotificationFilterStore.getData() });
    }

    private onDelete = (filterId) => {
        const filter = this.state.data.find((ele) => ele.FilterId == filterId);
        NotificationAction.deleteNotificationFilter(filter);
    };

    public onSave(data: ClientNotificationFiltersModel): boolean {
        NotificationAction.putNotificationFilter(data);
        return;
    }

    private onReorder(newOrder: ClientNotificationFiltersModel[]) {
        const _newOrder = newOrder.map((ele, i) => {
            return { ...ele, FilterOrder: i + 1 };
        });
        return NotificationAction.orderNotificationFilter(_newOrder);
    }

    public onAdd(data: ClientNotificationFiltersModel): boolean {
        if (this.state.data?.length >= 15) {return;}

        NotificationAction.postNotificationFilter(data);
        return;
    }

    public render(): JSX.Element {
        return (
            <DashboardSummaryTiles
                data={this.state.data}
                onAdd={(v) => this.onAdd(v as ClientNotificationFiltersModel)}
                onSave={(v) => this.onSave(v as ClientNotificationFiltersModel)}
                onDelete={(id) => this.onDelete(id)}
                onReOrder={(newList) => this.onReorder(newList as ClientNotificationFiltersModel[])}
                currentTabIndex={DashboardTab.Notification}
                pressedId={this.state.pressedId}
            />
        );
    }
}
